export function getCookieCrossDomain(req) {
  const hostname = req ? req.hostname : window.location.hostname;
  const parts = hostname.split('.');
  const domain = parts.length > 2 ? `.${parts[parts.length - 2]}.${parts[parts.length - 1]}` : hostname;
  return domain;
}